import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const copyEl = (self, el) => {
  self._checkNoProcessingTask();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const working_layer = self._getWorkingLayerThrowable();
  const translate_transform = self._getTranslateTransformThrowable();
  if (!working_layer.getIsChildGraphicsEl(el)) {
    throw new Error(`layer 엘리먼트의 자식 엘리먼트만 복제할 수 있습니다.`);
  }
  const clone_el = el.cloneNode(true);
  working_layer_el.appendChild(clone_el);
  try {
    translate_transform.translate({
      el: clone_el,
      f: ({ el, svg_el }) => {
        const el_ctm = el.getCTM();
        if (el_ctm == null) {
          throw new Error(`엘리먼트의 CTM 을 구할 수 없습니다.`);
        }
        const el_consolidated_transform_matrix =
          CommonNS.UtilNS.getConsolidatedTransformMatrix(el) ??
          svg_el.createSVGMatrix();
        const transform = svg_el.createSVGTransform();
        transform.setTranslate(10, 10);
        const { matrix } = transform;
        return el_consolidated_transform_matrix
          .multiply(el_ctm.inverse())
          .multiply(matrix)
          .multiply(el_ctm)
          .multiply(el_consolidated_transform_matrix.inverse());
      },
    });
  } catch (error) {
    CommonNS.UtilNS.tryNoop(() => working_layer_el.removeChild(clone_el));
    error.message = `엘리먼트를 복사하는 데 실패했습니다. : ${error.message}`;
    throw error;
  }
  working_layer_el.dispatchEvent(
    new CustomEvent(`@mp/sticker-editor/add`, {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        el: clone_el,
      },
    })
  );
  return clone_el;
};
